import { formatDateAndTime } from '@/helpers/dateHelpers';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

import { useSelf } from '@/data/user';

const Message = ({ message }) => {
  const self = useSelf();

  const isUsersMessage = self.data.id === message.userId;

  return (
    <div
      key={message.id}
      className={`flex mb-4 ${
        isUsersMessage ? 'justify-end' : 'justify-start'
      }`}
    >
      <div
        className={`flex ${
          isUsersMessage ? 'flex-row-reverse' : 'flex-row'
        } items-end`}
      >
        <Avatar className="w-8 h-8">
          <AvatarImage
            src={message.user?.avatar}
            alt={`${message.userFirstname} ${message.userLastname}`}
          />
          <AvatarFallback>
            {message.userFirstname.slice(0, 1).toUpperCase()}
            {message.userLastname.slice(0, 1).toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <div
          className={`max-w-xs mx-2 p-3 rounded-lg ${
            isUsersMessage ? 'bg-primary text-primary-foreground' : 'bg-muted'
          }`}
        >
          <p>{message.content}</p>
          <p className="text-xs mt-1 opacity-70">
            {formatDateAndTime(message.createdAt)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Message;
